import { render, staticRenderFns } from "./PersonalCategories.vue?vue&type=template&id=8168eb46&scoped=true&"
import script from "./PersonalCategories.vue?vue&type=script&lang=js&"
export * from "./PersonalCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8168eb46",
  null
  
)

export default component.exports